import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../../../core/Constants';


@Injectable()
export class ProductConfiguratorModalService {

  constructor(private http: HttpClient) { }

  SendConfiguratorEmail(json): Promise<any> {
    var url = `${Constants.API_CMS_ENDPOINT}/angular/iconfigurator/email`;
    return this.http.post(url, json).toPromise();
  }
}
